import {Component, Input, OnInit} from '@angular/core';
import {DocumentsService} from '../../common/documents.service';
import {SharedDocumentsPackage} from '../../common/shared-documents-package';
import {Cirf} from '../../cirf/cirf';
import {Referral} from '../../referral/referral';
import {UnityConnectTransactionType} from '../../common/model/unity-connect-transaction-type';
import {UnityConnectTransaction} from '../../common/model/unity-connect-transaction';
import {CirfService} from '../../cirf/cirf.service';
import {ReferralService} from '../../referral/referral.service';
import {MatterInfo} from '../../common/matter-info';
import {connectApi} from "../../common/connect-api";
import {HttpClient} from "@angular/common/http";
import { CommonService } from '../../common/common.service';
import { StaffProfiles } from '../../common/model/staff-profiles';
import {MatterEvent} from '../../common/matter-event';
import {Router} from "@angular/router";


@Component({
    selector: 'dp-connect-matter-info',
    templateUrl: './matter-info.component.html'})
export class MatterInfoComponent implements OnInit{

    @Input('matterInfo') matterInfo: MatterInfo;
    @Input('isFileStatusVisible') isFileStatusVisible: boolean;
    logoImageUrl: string;
    sharedDocumentsPackage : SharedDocumentsPackage;

    constructor(private documentsService: DocumentsService,
                private httpClient : HttpClient,
                private cirfService: CirfService,
                private router: Router,
                private referralService: ReferralService) {
    }

    ngOnInit(): void {
    }

    async loadMatterInfo(uct: UnityConnectTransaction){
        if(uct) {
            const id = uct.guid;
            let matterInfo: MatterInfo;
            if (uct.isTransactionUnProccesedReferral()) {
                let result = await   this.httpClient.get<Referral>(connectApi.getReferrals + id).toPromise();
                if (result && !!result['Referral']) {
                    let referral = new Referral(result['Referral']);
                    this.matterInfo = new MatterInfo();
                    this.matterInfo.lawFirm = uct.lawFirm;
                    this.matterInfo.propertyAddress = referral.referralForm.propertyAddress;
                    this.matterInfo.lawFirmFullAddress = referral.referralForm.receivingSolicitorAddress;
                    this.matterInfo.matterDescription = referral.client ? 'Referral of ' + referral.client : '';
                }

            } else {
                if (uct?.matterId) {
                    matterInfo = await this.cirfService.getMatterInfoByMatterId(uct?.matterId + '').toPromise();
                }
            }

            // if (uct.transactionType === 'SHARED_DOCUMENT_PACKAGE'){
            //     this.sharedDocumentsPackage = await this.documentsService.getSharedDocumentsPackageByGuid(id).toPromise();
            //     matterInfo = this.sharedDocumentsPackage.matterInfo;
            //     if(matterInfo && !matterInfo.provinceCode){
            //         matterInfo.provinceCode = this.sharedDocumentsPackage.provinceCode;
            //     }
            //
            // } else if (uct.transactionType === 'CIRF'){
            //     matterInfo = await this.cirfService.getCirfMatterInfo(id).toPromise();
            // }
            // else if (uct.transactionType === 'REFERRAL'){
            //     matterInfo = await this.referralService.getReferralMatterInfo(id).toPromise();
            // }

            if (matterInfo) {
                this.matterInfo = matterInfo;
                this.loadFirmLogo(id, uct.transactionType);
            }
        }
    }

    loadFirmLogo(id: string, transactionType: UnityConnectTransactionType) {
        if (transactionType === 'SHARED_DOCUMENT_PACKAGE') {
            this.loadFirmLogoForSharedDocPackage(id);
        } else if (transactionType === 'REFERRAL') {
            this.loadFirmLogoForReferral(id);
        } else if (transactionType === 'CIRF') {
            this.loadFirmLogoForCirf(id);
        }
    }

    loadFirmLogoForSharedDocPackage(id: string){
        if (id && this.matterInfo?.logoFirmFileId) {
            this.logoImageUrl = this.documentsService.getSharedDocPackageLogoFirm(id, this.matterInfo.logoFirmFileId);
        }
    }

    loadFirmLogoForCirf(id: string){
        if (id && this.matterInfo?.logoFirmFileId) {
            this.logoImageUrl = this.cirfService.getCirfLogoFirm(id, this.matterInfo.logoFirmFileId);
        }
    }

    loadFirmLogoForReferral(id: string){
        if (id && this.matterInfo?.logoFirmFileId) {
            this.logoImageUrl = this.referralService.getReferralLogoFirm(id, this.matterInfo.logoFirmFileId);
        }
    }

    get matterDescription() : string {
        if(this.matterInfo?.projectName && this?.sharedDocumentsPackage?.isUserOtherPartyProjectLawyerOrLawClerk()) {
            if(this.matterInfo?.matterDescription){
                return this.matterInfo.projectName + ' - ' + this.matterInfo?.matterDescription;
            }
            else{
                return this.matterInfo.projectName;
            }
        } else {
            return this.matterInfo?.matterDescription;
        }
    }

    isZoomMeeting (appointment: MatterEvent): boolean{
        return appointment && appointment.meetingLink && appointment.eventLocation && appointment.eventLocation === "ZOOM" ;
    }

    isMsTeamsMeeting (appointment: MatterEvent): boolean{
        return appointment && appointment.meetingLink && appointment.eventLocation && appointment.eventLocation === "MS_TEAMS" ;
    }

    isGoogleMeetMeeting (appointment: MatterEvent): boolean{
        return appointment && appointment.meetingLink && appointment.eventLocation && appointment.eventLocation === "GOOGLE_MEET" ;
    }

    isVortualMeeting (appointment: MatterEvent): boolean{
        return this.isZoomMeeting(appointment) || this.isMsTeamsMeeting(appointment) || this.isGoogleMeetMeeting(appointment);
    }

    getMettingIcon(meetingLocation: string): string{
        switch (meetingLocation) {
            //case 'ZOOM': return 'assets/img/Zoom - Blue.png';
            case 'ZOOM': return 'assets/img/Zoom - Blue.svg';
            case 'MS_TEAMS': return 'assets/img/Microsoft_Teams_48x48.png';
            case 'GOOGLE_MEET': return 'assets/img/Google-Meet.png';
            default: return '';
        }
    }
    getMettingIconSize(meetingLocation: string): string{
        switch (meetingLocation) {
            case 'ZOOM': return 'width-30-percent';
            case 'MS_TEAMS': return 'width-100-percent';
            case 'GOOGLE_MEET': return 'width-10-percent';
            default: return '';
        }
    }

    returnToOverview() : void {
        this.router.navigate(['./home/matter-summary-home'], {state: {nextState: 'refresh'}});
    }
}
